import * as React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const CustomLabel = ({ children }: { children: React.ReactNode }) => {
    const theme = useTheme();

    return (
        <Typography
            variant="caption"
            sx={{
                color: theme.palette.mode === "light"
					? theme.palette.grey[800]
					: theme.palette.grey[300],
                fontSize: 12,
                fontWeight: 400,
            }}
        >
            {children}
        </Typography>
    );
};
